// extracted by mini-css-extract-plugin
export default {"fr-view":"Standalone_fr-view__kPpDV","droppable":"Standalone_droppable__W+enQ","isDraggingOver":"Standalone_isDraggingOver__RC9cu"};